module.exports = __webpack_public_path__ + "static/media/FFS.5a6de7c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/assets/FFS.png
// module id = 651
// module chunks = 0